import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export default function PrivacyPage() {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold mb-2">Política de Privacidade</h1>
          <p className="text-muted-foreground">
            Última atualização: {new Date().toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' })}
          </p>
        </div>

        <Card>
          <CardContent className="pt-6 space-y-6">
            <section>
              <h2 className="text-xl font-semibold mb-3">1. Introdução</h2>
              <p className="text-muted-foreground leading-relaxed">
                A FotUP está comprometida em proteger sua privacidade. Esta Política de Privacidade explica como coletamos, 
                usamos, divulgamos e protegemos suas informações pessoais quando você usa nossa plataforma.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">2. Informações que Coletamos</h2>
              <p className="text-muted-foreground leading-relaxed mb-2">
                Coletamos os seguintes tipos de informações:
              </p>
              <div className="space-y-3">
                <div>
                  <h3 className="font-medium mb-1">Informações Pessoais</h3>
                  <ul className="list-disc list-inside text-muted-foreground space-y-1 ml-4">
                    <li>Nome completo</li>
                    <li>Endereço de e-mail</li>
                    <li>Número de telefone</li>
                    <li>CPF (quando aplicável)</li>
                    <li>Informações de pagamento</li>
                  </ul>
                </div>
                <div>
                  <h3 className="font-medium mb-1">Informações de Uso</h3>
                  <ul className="list-disc list-inside text-muted-foreground space-y-1 ml-4">
                    <li>Endereço IP</li>
                    <li>Tipo de navegador</li>
                    <li>Páginas visitadas</li>
                    <li>Data e hora de acesso</li>
                    <li>Dispositivo utilizado</li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">3. Como Usamos suas Informações</h2>
              <p className="text-muted-foreground leading-relaxed mb-2">
                Utilizamos suas informações para:
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-1 ml-4">
                <li>Fornecer e melhorar nossos serviços</li>
                <li>Processar transações e pagamentos</li>
                <li>Enviar notificações sobre sua conta e atividades</li>
                <li>Responder a suas solicitações e perguntas</li>
                <li>Personalizar sua experiência na plataforma</li>
                <li>Enviar comunicações de marketing (com seu consentimento)</li>
                <li>Detectar e prevenir fraudes e abusos</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">4. Compartilhamento de Informações</h2>
              <p className="text-muted-foreground leading-relaxed">
                Não vendemos suas informações pessoais. Podemos compartilhar suas informações apenas nas seguintes situações:
              </p>
              <ul className="list-disc list-inside text-muted-foreground mt-2 space-y-1 ml-4">
                <li>Com prestadores de serviços que nos ajudam a operar nossa plataforma</li>
                <li>Quando exigido por lei ou processo legal</li>
                <li>Para proteger nossos direitos e segurança</li>
                <li>Com seu consentimento explícito</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">5. Segurança dos Dados</h2>
              <p className="text-muted-foreground leading-relaxed">
                Implementamos medidas de segurança técnicas e organizacionais apropriadas para proteger suas informações 
                pessoais contra acesso não autorizado, alteração, divulgação ou destruição. No entanto, nenhum método de 
                transmissão pela Internet ou armazenamento eletrônico é 100% seguro.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">6. Cookies e Tecnologias Similares</h2>
              <p className="text-muted-foreground leading-relaxed">
                Utilizamos cookies e tecnologias similares para melhorar sua experiência, analisar o uso da plataforma e 
                personalizar conteúdo. Você pode controlar o uso de cookies através das configurações do seu navegador.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">7. Seus Direitos</h2>
              <p className="text-muted-foreground leading-relaxed mb-2">
                Você tem o direito de:
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-1 ml-4">
                <li>Acessar suas informações pessoais</li>
                <li>Corrigir informações incorretas ou incompletas</li>
                <li>Solicitar a exclusão de suas informações</li>
                <li>Opor-se ao processamento de suas informações</li>
                <li>Solicitar a portabilidade de seus dados</li>
                <li>Retirar seu consentimento a qualquer momento</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">8. Retenção de Dados</h2>
              <p className="text-muted-foreground leading-relaxed">
                Mantemos suas informações pessoais apenas pelo tempo necessário para cumprir os propósitos descritos nesta 
                política, a menos que um período de retenção mais longo seja exigido ou permitido por lei.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">9. Alterações nesta Política</h2>
              <p className="text-muted-foreground leading-relaxed">
                Podemos atualizar esta Política de Privacidade periodicamente. Notificaremos você sobre quaisquer alterações 
                significativas publicando a nova política nesta página e atualizando a data de "Última atualização".
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">10. Contato</h2>
              <p className="text-muted-foreground leading-relaxed">
                Se você tiver dúvidas ou preocupações sobre esta Política de Privacidade ou sobre como tratamos suas informações, 
                entre em contato conosco através de nossa página de Contato.
              </p>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

